import { css } from 'styled-components';

export const vknoTheme = css`
    --color-primary: #168016;
    
    --color-state-primary: rgba(22, 128, 22, 0.07);
    --color-state-secondary: rgba(22, 128, 22, 0.24);
    --color-state-tertiary: rgba(48, 49, 48, 0.07);

    --color-outline: rgb(119, 201, 119);

    /* Home Page */
    --home-hero-background: linear-gradient(84deg, #FDD072 33.51%, #FFD886 57.82%);
    --home-hero-title-color: black;
    --home-hero-subtitle-color: black;

    /* Subscription Page */
    --subscription-hero-background: #FFF3DA;
    --subscription-hero-title-color: black;
    --subscription-hero-subtitle-color: black;

    /* User Shortcuts */
    --color-outline-accent: #55BB55;
`;
